<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md12 lg12 xl12>
        <h2 class="pl-4">
          <span>My</span>
          <span class="blue--text"> Services</span>
        </h2>
      </v-flex>
      <v-flex v-for="service in services" :key="service.src" xs6 sm3 md3 lg3 xl3>
        <v-card
          hover
          flat
          color="transparent"
          :style="{ cursor: (service.href || service.to) ? 'pointer' : 'context-menu' }"
          :to="service.to"
          :href="service.href"
          :target="service.href ? '_blank' : undefined"
        >
          <v-card-title></v-card-title>
          <v-img :src="service.src" height="100" aspect-ratio="2.75" :alt="'Silvas do ' + service.title"
            :title="service.notes" lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
            contain></v-img>
          <v-card-title class="justify-center">
            <v-flex text-xs-center subheading font-weight-bold>{{ service.title }}</v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <h2 class="pl-4">
          <span>My</span>
          <span class="blue--text"> Clients</span>
        </h2>
      </v-flex>

      <v-flex v-for="client in clients" :key="client.src" xs6 sm4 md3 lg3 xl2>

        <div v-if="client.visible" st>
          <v-card flat :href="client.href" target="_blank" color="transparent">
            <v-hover>
              <!-- lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif" -->
              <v-img slot-scope="{ hover }" :src="client.src" :alt="client.name + ' logo'" :title="client.name"
                lazy-src="/fluid-loader2.gif" height="100" width="160" aspect-ratio="2.75" contain >
                <v-expand-transition>
                  <div v-if="!hover" class="transition-fast-in-fast-out blue v-img--reveal" style="height: 100%;"></div>
                </v-expand-transition>
              </v-img>

            </v-hover>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: "Services",
    titleTemplate: "%s ← IT Contractor | Silva's SCS Inc",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Silva's Services Web Development Video Editing Graphic Design Front-End Advetising"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "IT Contractor | Silva's SCS Inc" },
      { property: "og:site_name", content: "IT Contractor | Silva's SCS Inc" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://silvassoftwareconsultingservices.com" },
      {
        property: "og:image",
        content: "/favicon_io/apple-touch-icon.png"
      },
      {
        property: "og:description",
        content:
          "Silva's Services Web Development Video Editing Graphic Design Front-End Advetising"
      }
    ]
  },
  data() {
    return {
      clients: [
        {
          name: "Possession Partners LLC",
          src: "/possession_parther_logo.png",
          href: "https://possessionpartner.com/",
          visible: process.env.PP_LOGO_ENABLED === true
        },
        {
          name: "Web Geeks Inc.",
          src: "/Web-Geeks-Dark-Icon-Logo.png",
          href: "https://webgeeks.com/",
          visible: true
        },
        {
          name: "Mach2d Solutions Inc.",
          src: "/mach2dsolutions_logo.png",
          href: "https://mach2dsolutions.com",
          visible: true
        },
        {
          name: "Upwork",
          src: "/upwork_logo.svg",
          href: "https://www.upwork.com/freelancers/luissilva2014",
          visible: true
        },
        {
          name: "Freelancer",
          src: "/freelancer_logo_icon_171123.webp",
          href: "https://www.freelancer.ca/u/luissscs",
          visible: true
        },
        
        {
          name: "Mercor",
          src: "/mercor_logo.png",
          href: "https://www.mercor.com/careers",
          visible: true
        },
        {
          name: "Hunter Warfield",
          src: "/hunter_warfield_logo.png",
          href: "https://www.residentinterface.com/solutions/possession-partner",
          visible: true
        },
        {
          name: "Fusion Payson Church",
          src: "/fusion_payson_church_logo.png",
          href: "https://fusionpayson.org/",
          visible: true
        },
        // {
        //   name: "Your Company! Inc.",
        //   src: "/yourcompany.com",
        //   href: "https://silvassoftwareconsultingservices.com/",
        //   visible: true
        // },
      
      ],
      services: [
        {
          src: "/Custom_Web_Solutions_Developer.png",
          title: "Custom Web Solutions Developer",
          notes: "Need a custom web solution? I can help you with that."
        },
        {
          src: "/PHP_Laravel_Certified.png",
          href: "https://verifier.certificationforlaravel.org/c1752575-c0cf-4242-81f9-c7b04e298d55",
          title: "Solution PHP/Laravel Developer",
          notes: "PHP, Laravel, MySQL, JavaScript, Vue.js"
        },
        {
          src: "/W3Schools_Professional_Certified.svg",
          to: { path: "/career", hash: "#education" },
          title: "W3Schools Professional Program",
          notes: "Certified C# and React Professional Developer"
        },
        {
          src: "/Microsoft_Stack_Web_Developer.png",
          title: "Microsoft Stack Web Developer",
          notes: "ASP.NET, C#, .Net Core, SQL Server, Azure"
        },
        // {
        //   src: "/Code_Quality_Assurance_Lead.png",
        //   title: "Code Quality Assurance Lead",
        //   notes: "Need an experienced code reviewer that pays attention to details and follows standards? Let me help you."
        // },
        {
          src: "/Containerization_Consultant.png",
          title: "Containerization Consultant",
          notes: "Docker other containerization technologies."
        },
        {
          src: "/Mobile_Solutions_Developer.png",
          title: "Mobile Solutions Developer",
          notes: "App builder using React Native "
        },
        {
          src: "/Data-Driven_Solutions_Developer.png",
          title: "Data-Driven Solutions Developer",
          notes: "Need a data-driven solution? I can help you with that."
        },
        {
          src: "/IT_Staffing_Solutions_Provider.png",
          title: "IT Staffing Solutions Provider",
          notes: "You need a team? I can help you find the right people for your project."
        },
      ]
    };
  }
};
</script>
<style>
.v-img--reveal {
  opacity: 0.3;
}
</style>